








































































import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import moneyFormat from "@/filters/money-format";
import Vue from "vue";
import { t } from "@/plugins/i18n";

interface Computed{
    url: string;
    columns: ApiSearchColumn[];
}

interface Props{
    partnerId: number;
}

export default Vue.extend<{}, {}, Computed, Props>({
    components:{
        ApiSearchPage
    },

    props: {
        partnerId: Number
    },

    computed: {
        url(){
            return `emails/search/${this.partnerId}`;
        },

        columns: (): ApiSearchColumn[] => [
        { field: "email", title: "Email" },
        { field: "success", title: t("Partner_Sikeres"), cell: 'success' },
        { field: "error", title: t("Hiba_2"), cell: 'error' },
        { field: "insUser", title: t("Partner_KikuldoFelhasznalo") },
        { title: t("Partner_KikuldesDatuma"), field: "insDate", filterable: false, type: ColumnType.Date },
        { cell: 'statementDetailsButtonTemplate', title: '', field: 'id', headerClass: "detailsColumn", filterable: false, sortable: false}
    ],
    }
})
